var path = 'app/scripts/modules/google/src/serverGroup/configure/wizard/zones/regionalSelector.directive.html';
var html = "<div class=\"form-group\">\n  <div class=\"col-md-3 sm-label-right\"><b>Regional</b></div>\n  <div class=\"col-md-7 checkbox\">\n    <label><input type=\"checkbox\" ng-model=\"vm.command.regional\"/>\n      Distribute instances across multiple zones\n    </label>\n    <label ng-if=\"vm.command.regional\"><input type=\"checkbox\" ng-model=\"vm.command.selectZones\"/>\n      Select zones explicitly\n    </label>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/zones/regionalSelector.directive.html
// module id = 1362
// module chunks = 0